import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

import "../assets/css/Banner.css"; // Create and use this for styling

const Banner = () => {
  const slides = [
    {
      title: "Appointment and Patient Data Management",
      desc: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Maiores, delectus placeat hic voluptatem fuga.",
      img: "/uploads/media-21042382285e049caa72dcd.jpg",
    },
    {
      title: "Complete Health Care Solution for Clinic",
      desc: "This is tag line ipsum dolor sit amet, consectetur Nihil cupiditate. #twitterhash, @facebooktag",
      img: "/uploads/media-12305327725e049caa750d0.jpg",
    },
    {
      title: "During your Entire Lifetime We Are There",
      desc: "Lorem ipsum dolor sit amet, consectetur adipisicin voluptatem fuga. #twitterhash, @facebooktag",
      img: "/uploads/media-12305327725e049caa750d0.jpg",
    },
  ];

  return (
    <>

    <div id="slider" className="slider ">
      <Swiper
        spaceBetween={0}
        centeredSlides={true}
        autoplay={{
          delay: 4000,
          disableOnInteraction: false,
        }}
        pagination={{
          clickable: true,
        }}
        navigation={true}
        loop={true}
        modules={[Autoplay, Pagination, Navigation]}
        className="mySwiper"
      >
        {slides.map((slide, index) => (
         <SwiperSlide key={index}>
  <div
    className="slider-background-image"
    style={{
      backgroundImage: `url(${slide.img})`,
    }}
  >
    {/* Black overlay */}
    <div className="black-overlay" />
    
    {/* Slide content */}
    <div className="slider-info">
      <h1 className="animated fadeInDown">{slide.title}</h1>
      <p className="animated fadeInDown">{slide.desc}</p>
    </div>
  </div>
</SwiperSlide>

        ))}
      </Swiper>

      {/* <div className="slider-appointment"> */}
        {/* <a href="/login" className="animated fadeInUp">
          <i className="far fa-calendar-plus mr-2" />
          Make An Appointment
        </a> */}
      {/* </div> */}
    </div>
    </>
  );
};

export default Banner;
